"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InteractionHelper = void 0;
const moment_1 = __importDefault(require("moment"));
class InteractionHelper {
    static getAllDrivers(interaction) {
        const drivers = [];
        if (interaction) {
            if (interaction.policyHolder) {
                drivers.push(interaction.policyHolder);
            }
            if (interaction.additionalDrivers) {
                drivers.push(...interaction.additionalDrivers);
            }
        }
        return drivers;
    }
    static getDrivingLicenceNumber(driver) {
        var _a;
        const dln = (_a = driver === null || driver === void 0 ? void 0 : driver.licence) === null || _a === void 0 ? void 0 : _a.number;
        return dln && dln.replace(/\s+/g, '').toUpperCase();
    }
    /**
     * Determines whether 2 drivers are the same person.
     *
     * Note: If at least one of the drivers doesn't have a DLN,
     * then both drivers' DLNs are considered equal,
     * regardless whether or not the other driver has a DLN.
     * Source: FAL-18277 (https://lv-digital.atlassian.net/browse/FAL-18277)
     *
     * @param driver1 - driver to compare
     * @param driver2 - driver to compare
     * @returns true if drivers are equal; false otherwise
     */
    static driversEqual(driver1, driver2) {
        var _a, _b;
        if (!driver1 || !driver2) {
            throw new Error(`Cannot compare drivers: ${!driver1 ? "driver1" : "driver2"} is undefined`);
        }
        const dln1 = (_a = this.getDrivingLicenceNumber(driver1)) === null || _a === void 0 ? void 0 : _a.slice(0, 16);
        const dln2 = (_b = this.getDrivingLicenceNumber(driver2)) === null || _b === void 0 ? void 0 : _b.slice(0, 16);
        let dlnsEqual;
        if (!dln1 || !dln2) {
            dlnsEqual = true;
        }
        else {
            dlnsEqual = dln1 === dln2;
        }
        return (dlnsEqual &&
            driver1.firstName.toLowerCase() === driver2.firstName.toLowerCase() &&
            driver1.lastName.toLowerCase() === driver2.lastName.toLowerCase() &&
            moment_1.default.utc(driver1.dateOfBirth).startOf("day").isSame(moment_1.default.utc(driver2.dateOfBirth).startOf("day")));
    }
    static isMonthlyQuoteAllowed(interaction) {
        var _a;
        return ((_a = interaction.polarisPolicyData) === null || _a === void 0 ? void 0 : _a.instalmentAllowedStatus) === "A";
    }
    static hasQuoteExpired(interaction) {
        var _a, _b;
        if (!((_a = interaction === null || interaction === void 0 ? void 0 : interaction.headerInfo) === null || _a === void 0 ? void 0 : _a.expiryDate) || !((_b = interaction === null || interaction === void 0 ? void 0 : interaction.headerInfo) === null || _b === void 0 ? void 0 : _b.startDate)) {
            return false;
        }
        return this.isQuoteExpiredByDates(interaction.headerInfo.startDate, interaction.headerInfo.expiryDate, interaction.status);
    }
    static isQuoteExpiredByDates(startDate, expiryDate, status) {
        if (status === "AGREEMENT")
            return true;
        const now = (0, moment_1.default)();
        return now.isAfter(expiryDate)
            || now.isAfter(startDate, "day");
    }
}
exports.InteractionHelper = InteractionHelper;
//# sourceMappingURL=InteractionHelper.js.map